const DEVICE_KEY_STORAGE = "mercari_device_key";

function safeWindow() {
  return typeof window !== "undefined" ? window : null;
}

function ensureDeviceKey(win) {
  if (!win) {
    return "server-render";
  }
  try {
    const existing = win.localStorage.getItem(DEVICE_KEY_STORAGE);
    if (existing) {
      return existing;
    }
    const key = (win.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`) + "";
    win.localStorage.setItem(DEVICE_KEY_STORAGE, key);
    return key;
  } catch (_err) {
    return "fallback-key";
  }
}

export function getDeviceFingerprint() {
  const win = safeWindow();
  if (!win) {
    return {
      device_key: "server-render",
      user_agent: undefined,
      platform: undefined,
      timezone: undefined,
      screen: undefined,
      webgl: undefined,
      ip_address: undefined,
    };
  }

  const nav = win.navigator || {};
  const screen = win.screen || {};
  let screenDescriptor;
  if (screen && typeof screen.width === "number" && typeof screen.height === "number") {
    screenDescriptor = `${screen.width}x${screen.height}`;
  }

  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (_err) {
    timezone = undefined;
  }

  let webgl;
  try {
    const canvas = win.document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (gl) {
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (debugInfo) {
        webgl = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }
  } catch (_err) {
    webgl = undefined;
  }

  return {
    device_key: ensureDeviceKey(win),
    user_agent: nav.userAgent,
    platform: nav.platform,
    timezone,
    screen: screenDescriptor,
    webgl,
    ip_address: undefined,
  };
}
